import { Link } from '@tiptap/extension-link';
import { Table } from '@tiptap/extension-table';
import { TableCell } from '@tiptap/extension-table-cell';
import { TableHeader } from '@tiptap/extension-table-header';
import { TableRow } from '@tiptap/extension-table-row';
import StarterKit from '@tiptap/starter-kit';

/**
 * The single TipTap extension set for legal pages, shared by the live editor
 * (`LegalEditor`) and the headless JSON->HTML renderer (`renderLegalContentHtml`).
 * Keeping one definition guarantees the editor preview, the saved output, and the
 * reader-facing HTML are all generated from an identical schema and can never
 * drift apart.
 */
export const legalEditorExtensions = () => [
  StarterKit.configure({ heading: { levels: [1, 2, 3] } }),
  Link.configure({
    openOnClick: false,
    defaultProtocol: 'https',
    protocols: ['http', 'https', 'mailto'],
  }),
  Table.configure({ resizable: true }),
  TableRow,
  TableCell,
  TableHeader,
];
